import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';
import { useSession } from '../contexts/SessionContext';

interface Props {
  style?: React.CSSProperties;
  className?: string;
  children: React.ReactNode;
}
const Layout = ({ style, className, children }: Props) => {
  const { loading, loadingContent } = useSession();

  return (
    <div className={className} style={{ position: 'relative', width: '100%', height: '100%', ...style }}>
      {loading && (
        <>
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
            <Spin size="large" />
          </div>
          <div
            style={{
              position: 'absolute',
              left: '10px',
              bottom: '10px',
              display: 'flex',
              alignItems: 'center',
              color: '#999',
              zIndex: 1000,
            }}
          >
            <LoadingOutlined
              style={{
                color: '#999',
                fontSize: '12px',
              }}
            />
            {loadingContent}
          </div>
        </>
      )}
      {children}
    </div>
  );
};

const Footer = ({ style, className, children }: Props) => {
  return (
    <div
      className={className}
      style={{
        position: 'fixed',
        bottom: '20px',
        right: '20px',
        zIndex: 1000,
        display: 'flex',
        justifyItems: 'flex-end',
        gap: '10px',
        ...style,
      }}
    >
      {children}
    </div>
  );
};
export default { Layout, Footer };
